import type {DataRouter} from 'react-router'
import {isChromelessPathname} from '@freckle/classroom/ts/hooks/chromeless/is-chromeless-path'
import {postMessageToWildcard} from '@freckle/classroom/ts/hooks/use-chromeless-post-message'

/**
 * Asks the Renaissance Next parent frame to show its spinner whenever the user navigates to a
 * different chromeless page, so individual links and handlers do not need to.
 *
 * Every chromeless route MUST answer with `useChromelessPostAssignmentPageLoaded`, otherwise the
 * parent's spinner never goes away.
 *
 * Only pathname changes count: search/hash-only changes (e.g. switching report tabs) stay on the
 * same page, which would not post a new `initialization_complete` for the spinner to clear on.
 */
export const showChromelessSpinnerOnNavigation = (router: DataRouter): (() => void) => {
  let lastPathname = router.state.location.pathname

  return router.subscribe(({location}) => {
    if (location.pathname === lastPathname) return
    lastPathname = location.pathname

    if (isChromelessPathname(location.pathname)) {
      postMessageToWildcard({
        message: {source: 'renaissance_next_apps_fr+update_ui', update: 'show_spinner'}
      })
    }
  })
}
